// extracted by mini-css-extract-plugin
var _1 = "Uploader-module__container--itcCH";
var _2 = "Uploader-module__info--xSIzF";
var _3 = "Uploader-module__uploader--mpnaH";
var _4 = "Uploader-module__uploaderAccept--RBYsK";
var _5 = "Uploader-module__uploaderBorder--mHdSo";
var _6 = "Uploader-module__uploaderBorderContainer--rnn9i";
var _7 = "Uploader-module__uploaderIcon--AIHrg";
var _8 = "Uploader-module__uploaderReject--LzJOs";
var _9 = "Uploader-module__wrappingGroup--qPUV9";
export { _1 as "container", _2 as "info", _3 as "uploader", _4 as "uploaderAccept", _5 as "uploaderBorder", _6 as "uploaderBorderContainer", _7 as "uploaderIcon", _8 as "uploaderReject", _9 as "wrappingGroup" }
